import './columns.sass';
import { getSimpleFunctionalComponent } from '../../../utils/getSimpleFunctionalComponent';

export default getSimpleFunctionalComponent('column', 'div');
